import actions from '@/store/modules/project/actions.js'
import mutations from '@/store/modules/project/mutations.js'
import getters from '@/store/modules/project/getters.js'
import {base_state} from '@/store/modules/base/state'

const state = {
  ...base_state,
  'api_module': 'project',
  'favourites': {},
  'users': {}
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}